<template>
  <div class="footer">
    <div class="footer-inner">11111</div>
  </div>
</template>

<script>

export default {
  data () {
    return {
      options: {},
    };
  },
  components: {

  },
  props: {
    
  },
  watch: {
    
  },
}
</script>
<style lang="scss" scoped>
.footer{
  position: fixed;
  bottom:0;
  left:50%;
  transform: translateX(-50%);
  width:600px;
  height:0;
  border-width:0 37px 52px 37px;
  border-style:none solid solid;
  border-color:transparent transparent #2FA49F;
  overflow: hidden;
  .footer-inner{
    width:100%;
    height:100%;
    background: linear-gradient(180deg, rgba(47, 164, 159, 0.11) 0%, rgba(1, 177, 169, 0.06) 79%, rgba(53, 149, 147, 0.11) 100%);
  }
}
</style>